/**
 * Shared keyset of the agent-app integrations tab (YCP). Used by both the internal and external
 * agent pages, so it must not depend on either page's form keyset.
 */
export const en = {
    "side-menu-integrations": "YCP",
    "field-ycp-host": "Website domain",
    "field-ycp-host-description": "Your website's domain (no scheme or path) — used when building checkout links.",
    "field-ycp-host-placeholder": "shop.example.ru",
    "validation-ycp-host": "Enter a valid domain, e.g. shop.example.ru",
    "toast-integrations-saved": "Integrations saved",
    "toast-save-error": "Failed to save",
    "toast-load-error": "Failed to load the agent",
} as const;

export const ru = {
    "side-menu-integrations": "YCP",
    "field-ycp-host": "Домен сайта",
    "field-ycp-host-description": "Домен вашего сайта (без схемы и пути) — используется при построении ссылок на оплату.",
    "field-ycp-host-placeholder": "shop.example.ru",
    "validation-ycp-host": "Введите корректный домен, например shop.example.ru",
    "toast-integrations-saved": "Подключения сохранены",
    "toast-save-error": "Не удалось сохранить",
    "toast-load-error": "Не удалось загрузить агента",
} as const;
